/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class ManageProcessClaimsModel {

        public newProcessClaim: Wars.Domain.Model.ClaimDefinition;
        public existingProcessClaims: Wars.Domain.Model.ClaimDefinition[];
        public systemClaimGroups: Wars.Domain.Model.ClaimGroup[];
        public processActions: Wars.Domain.Model.ProcessAction[];

        constructor(
            private processConfigurationId: string,
            private processConfigurationService: services.ProcessConfigurationService,
            private service: services.ClaimDefinitionService,
            private systemLevelService: services.SystemLevelService,
            private processActionService: services.ProcessActionService,
            private deleteService: services.DeleteService,
            private modalService: any)
        {
            this.existingProcessClaims = [];
            this.getExistingProcessClaims();

            this.systemLevelService.getSystemLevelClaimGroups().then(
                (systemLevel) => {
                    this.systemClaimGroups = systemLevel.myClaimGroups;
                });

            this.processActionService.getAllProcessActions(processConfigurationId).then((processActions) => {
                this.processActions = processActions;
            });
        }

        private getExistingProcessClaims(): void {
            this.service.getAllProcessClaims(this.processConfigurationId).then(
                (processClaims) => {
                    this.existingProcessClaims = processClaims
                });
        }

        public addNewProcessClaim(): void {
            this.newProcessClaim = this.service.createNewEntity<Wars.Domain.Model.ClaimDefinition>("ClaimDefinition");
            this.newProcessClaim.valueAssignable = false;
            this.newProcessClaim.valueType = undefined;
            this.newProcessClaim.uniqueIdentifier = services.UtilityService.generateGuidComb();
            this.newProcessClaim.processConfiguration_id = this.processConfigurationId;
            this.showModal(this.newProcessClaim, true);
        }

        public editExistingProcessClaim(claim: Wars.Domain.Model.ClaimDefinition): void {
            this.showModal(claim, false);
        }

        public deleteClaim(claim: Wars.Domain.Model.ClaimDefinition) {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "ClaimDefinition",
                claim.id,
                "Claim Definition",
                () => this.existingProcessClaims.remove(claim));
        }

        private showModal(claim: Wars.Domain.Model.ClaimDefinition, adding: boolean) { // Just provide a template url, a controller and call 'showModal'.
            var self: ManageProcessClaimsModel = this;
            this.modalService.showModal({
                templateUrl: "./app/views/modals/_claimEditModal.html",
                controller: "editClaimModalController",
                inputs: {
                    claim: claim,
                    mapping: { isMapped: false },
                    systemClaimGroups: this.systemClaimGroups,
                    variableTypeContext: null,
                    codeGroups: null,
                    processActions: this.processActions
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        if (adding) {
                            claim.processConfiguration_id = this.processConfigurationId;
                            this.existingProcessClaims.push(claim);
                        }
                        this.service.saveAllChanges();
                    } else {
                        self.service.rejectChanges();
                    }
                });
            });
        }
    }
}